import { safeHTML } from '../../../../utils/safeHTML'
import React from 'react'
import { rating as ratingData } from '../../../../constants/copyright'
import { useTranslation } from '../../../../translations'

const { title, ratingCount, subtitle } = ratingData

export default function RatingHeader() {
  const { t } = useTranslation()

  return (
    <>
      <h2 className={'rating__title'}>{safeHTML(t(title.new, { ratingCount }))}</h2>
      <p className={'rating__text'}>{safeHTML(t(subtitle.new))}</p>
    </>
  )
}
